import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hover:border hover:border-gray-300 hover:shadow-lg rounded-lg px-2 py-3 cursor-pointer group" }
const _hoisted_2 = { class: "flex gap-x-2.5 border-l-2 pl-2" }
const _hoisted_3 = { class: "w-5" }
const _hoisted_4 = { class: "flex flex-col gap-y-1 text-sm leading-5" }
const _hoisted_5 = { class: "font-medium text-gray-900 border-tea" }
const _hoisted_6 = { class: "font-normal text-gray-400 pe-2" }

import { Component } from "vue"

interface Props {
    title: string
    description: string
    icon: Component
    useFill?: boolean
    useStroke?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ActionItem',
  props: {
    title: {},
    description: {},
    icon: {},
    useFill: { type: Boolean },
    useStroke: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), {
          class: _normalizeClass([
                        _ctx.useFill
                            ? 'fill-gray-400 group-hover:fill-gray-900 '
                            : _ctx.useStroke
                            ? 'stroke-gray-400 group-hover:stroke-gray-900'
                            : 'text-gray-400 group-hover:text-gray-900',
                        'h-5 w-5 ',
                    ])
        }, null, 8, ["class"]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.description), 1)
      ])
    ])
  ]))
}
}

})